import { render, staticRenderFns } from "./ModalCPMEdit.vue?vue&type=template&id=12381a42&scoped=true&"
import script from "./ModalCPMEdit.vue?vue&type=script&lang=ts&"
export * from "./ModalCPMEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12381a42",
  null
  
)

export default component.exports